import { TooltipIcon } from "PFComponents/tooltip";
import { IconName } from "PFTheme/graphics/icons";

export type LabelIconConfig = {
  text?: string;
  icon: IconName;
  disabled?: boolean;
};

export const LabelIcon = ({ text: tooltipText, icon, disabled }: LabelIconConfig) => (
  <TooltipIcon
    key={`${icon}-${tooltipText}`}
    content={tooltipText}
    iconName={icon}
    tooltipProps={{ disabled, triggerContainerProps: { title: tooltipText } }}
    iconProps={{ size: "sm", tabIndex: -1 }}
  />
);
